import { footCell } from "../../modules/table.funcs"
import { yearsToString } from "../../modules/utilities"
import { COLUMN, FORMATTING, JARGON, LAYOUT } from "../../modules/constants"

const { border1, left } = FORMATTING

export const createNexusCommitteesFootersData = props => {
  // console.log('createCommitteesFootersData props:', props)
  return {
    totals: createFooterTotals(props),
  }
}

const createFooterTotals = ({ columns, isCompany, portrait, stats, the350club }) => {
  const align = LAYOUT.COMMITTEE.ALIGNMENT
  const borderLeft = portrait ? null : border1

  const cell = {
    [COLUMN.STAR]: footCell({ id: COLUMN.STAR }),
    [COLUMN.ROLE]: footCell({ id: COLUMN.ROLE }),
    [COLUMN.TENURE]: footCell({ id: COLUMN.TENURE, label: yearsToString(stats.tenure.total) }),
  }

  footCell({ align, borderLeft, cell, id: COLUMN.COMMITTEE.AUDIT.CHAIRS, label: stats.ac.total })
  footCell({ align, cell, id: COLUMN.COMMITTEE.AUDIT.MEMBER, label: stats.am.total })
  footCell({ align, cell, borderLeft, id: COLUMN.COMMITTEE.REMUNERATION.CHAIRS, label: stats.rc.total })
  footCell({ align, cell, id: COLUMN.COMMITTEE.REMUNERATION.MEMBER, label: stats.rm.total })
  footCell({ align, cell, borderLeft, id: COLUMN.COMMITTEE.NOMINATION.CHAIRS, label: stats.nc.total })
  footCell({ align, cell, id: COLUMN.COMMITTEE.NOMINATION.MEMBER, label: stats.nm.total })

  const nameFootText = stats.numRows === 1
    ? isCompany ? JARGON.PERSON : JARGON.COMPANY
    : isCompany ? JARGON.PEOPLE : JARGON.COMPANIES

  footCell({
    // id is only used for 'key', but safer to use matching and footer ids
    id: isCompany ? COLUMN.OFFICER : COLUMN.COMPANY,
    align: left,
    cell,
    label: `${stats.numRows} ${nameFootText}`
  })

  const cells = []

  for (const [key, value] of Object.entries(columns))
    if (value && cell[parseInt(key)])
      cells.push(cell[parseInt(key)])

  if (the350club) {
    cells.shift() // Remove the starHead
    cells[0].paddingLeft = LAYOUT.COLUMN_PADDING // .. and add some padding
  }

  return cells
}

